// Used on the tracks search page in combination with ColonSearch
// It serializes the form params in the format of "input1:value1/input2:value2"
$(document).on('submit', '.js-search-with-colons', function(e) {
  e.preventDefault();
  var inputs = $(this).serializeArray();
  // The inputs will appear in the same order as defined in allowedInputs
  var allowedInputs = [ "tech", "topic", "q", "from_search" ]

  // Inputs will be sorted in the same order as defined in allowedInputs
  inputs.sort(function(a, b) {
    var idxa = $.inArray(a.name, allowedInputs);
    var idxb = $.inArray(b.name, allowedInputs);
    if (idxa == idxb) { return 0 }
    return idxa > idxb ? 1 : -1;
  });

  var parts = $.map(inputs, function(input) {
    if ( $.inArray(input.name, allowedInputs) >= 0 && input.value && input.value != '') {
      return input.name + ':' + input.value;
    } else {
      return null;
    }
  });

  window.location.href = $(this).attr('action') + '/' + parts.join('/');
});
